import { render, staticRenderFns } from "./PageCredentials.vue?vue&type=template&id=23de993c&"
import script from "./PageCredentials.vue?vue&type=script&lang=js&"
export * from "./PageCredentials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports